import { useEffect } from "react";
import useAuthService from "../hooks/useAuthService";


const useAuthCheck = () => {
    const { LogoutUser } = useAuthService();
    useEffect(() => {
        const checkTokenExpiry = () => {
            const refreshExpiry = localStorage.getItem("refresh_token_expiry");
            if (!refreshExpiry || Date.now() > refreshExpiry) {
                LogoutUser();
            }
        };

        const interval = setInterval(checkTokenExpiry, 5*60000); // Check 5 minutes
        return () => clearInterval(interval);
    }, [LogoutUser]);
};

export default useAuthCheck;